package com.example.mystybag.e5AiSearch.helpers

import kotlinx.coroutines.*
import kotlinx.coroutines.sync.Mutex
import kotlinx.coroutines.sync.withLock
import kotlin.math.sqrt

object E5Runtime {
    private val mutex = Mutex()
    private var deferred: Deferred<Embedder>? = null

    suspend fun get(): Embedder = coroutineScope {
        val ctx = E5Platform.appContext()

        val d = mutex.withLock {
            deferred ?: async(start = CoroutineStart.LAZY) {
                val tokenizer = E5TokenizerProvider.get(ctx, "tokenizer.json")

                createEmbedder(
                    ctx = ctx,
                    tokenizer = tokenizer
                )
            }.also { deferred = it }
        }

        d.start()
        d.await()
    }

    suspend fun reset() {
        mutex.withLock { deferred = null }
    }

    data class DebugVec(
        val tag: String,
        val mode: String,
        val text: String,
        val dim: Int,
        val l2: Float,
        val first10: List<Float>
    )

    private fun l2(v: FloatArray): Float {
        var sum = 0f
        for (x in v) sum += x * x
        return sqrt(sum)
    }

    private fun cosine(a: FloatArray, b: FloatArray): Float {
        var s = 0f
        val n = minOf(a.size, b.size)
        for (i in 0 until n) s += a[i] * b[i]
        return s
    }

    suspend fun Embedder.debugEmbedding(tag: String, mode: String, text: String): DebugVec {
        val vec = when (mode) {
            "QUERY" -> embedQuery(text)
            "PASSAGE" -> embedDoc(text)
            "RAW" -> embedQuery(text)
            else -> error("Unknown mode=$mode")
        }

        return DebugVec(
            tag = tag,
            mode = mode,
            text = text,
            dim = vec.size,
            l2 = l2(vec),
            first10 = vec.take(10)
        )
    }

    fun logCosine(tag: String, a: FloatArray, b: FloatArray) {
        E5Platform.log("E5CMP", "$tag cosine=${cosine(a, b)}")
    }

    private suspend fun createEmbedder(
        ctx: PlatformContext,
        tokenizer: E5Tokenizer
    ): Embedder {
        val maxLen = 128
        val dim = 384

        val runner = E5Platform.createRunner(
            ctx = ctx,
            modelAssetName = "model_04.onnx",
            maxLen = maxLen,
            dim = dim
        )

        return E5Embedder(
            tokenizer = tokenizer,
            runner = runner,
            maxLen = maxLen,
            dim = dim
        )
    }
}